(function(){
  var slots = document.querySelectorAll('.adsbygoogle:not([data-loaded])');
  if(!slots.length) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting) return;
      var ins = e.target;
      ins.setAttribute('data-loaded','1');
      try{ (window.adsbygoogle = window.adsbygoogle || []).push({}); }catch(err){}
      io.unobserve(ins);
    });
  }, { rootMargin: '300px 0px' });
  slots.forEach(function(s){ io.observe(s); });
})();
